import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import CreditForm, { CreditFormOwnProps, CreditFormStateProps } from 'components/features/pfm/CreditForm/CreditForm'
import schema from 'schemas/creditFormSchema'
import extendedSchema from 'schemas/creditFormExtendedSchema'
import { asyncValidator } from 'helpers/schemaHelpers'
import { creditLinkagePhaseSelector } from 'selectors/creditSelectors'
import { onFormSubmit } from 'helpers/formHelpers'
import { isOnboardingFinishingSelector } from 'selectors/onboardingSelectors'
import { creditFormInitialValuesSelector, creditFormNameSelector, creditFormCityValueSelector } from 'selectors/creditSelectors'

const simpleValidator = asyncValidator(schema)
const extendedValidator = asyncValidator(extendedSchema)

const mapStateToProps = createSelector(
  creditFormInitialValuesSelector,
  creditLinkagePhaseSelector,
  isOnboardingFinishingSelector,
  creditFormNameSelector,
  creditFormCityValueSelector,
  (initialValues, phase, isOnboardingFinishing, form, cityStateValue): CreditFormStateProps => {
    const isExtended = phase === 'form-extended'

    return {
      initialValues,
      isExtended,
      asyncValidate: isExtended ? extendedValidator : simpleValidator,
      form,
      cityStateValue,
      onSubmit: onFormSubmit,
      isSubmitAllowed: !isOnboardingFinishing,
    }
  }
)

const CreditFormContainer = connect<CreditFormStateProps, {}, CreditFormOwnProps>(mapStateToProps)(CreditForm)
export default CreditFormContainer
